import React from "react"

const PlusSvg = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 40 40" data-icon="plus" fill="currentColor" aria-hidden="true">
      <g stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" fillRule="evenodd">
        <path d="M10 20 h20"></path>
        <path d="M20 10 v20"></path>
      </g>
    </svg>
  )
}

export default PlusSvg
